module.exports = __webpack_public_path__ + "img/grindylow_in_lupins_office.5b3c6332.jpg";